import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import "./similar-job-card.style.scss";
export default function SimilarJobCard({ data }) {
  return (
    <div className="similar-job-card-main">
      <div className="jocm-header">
        <div>
          <img src={Images.menTree} />
        </div>
      </div>

      <h5 className="job-title">{data?.jobTitle || "NA"}</h5>
      <p className="institute-name">{data?.clientName || "NA"}</p>
      <h6 className="location">
        <img src={Images.blueLocation} />
        <span>{data?.location || ""}</span>
      </h6>
      <div className="jocm-info">
        <span>
          <img src={Images.blueBook} />
          {data.custField1 || ""}
        </span>
        <span>
          <img src={Images.groupLogo} />
          10-50 Staffs
        </span>
        <span>
          <img src={Images.manWIthStars} />
          +{data?.minWorkExp} Yrs exp
        </span>
      </div>
      <div className="submit-wrapper">
      <Link to={`/user/description/${data.jobId}`} className="view-button">
        View Details
      </Link>

      </div>
    </div>
  );
}
